module.exports = __webpack_public_path__ + "static/media/slide-10.0d1a8427.png";